// tradesConfig.js
export const tradesConfig = {
    Electrician: [
      'Install lighting', 
      'Rewire a house', 
      'Install circuit breaker', 
      'Install sockets', 
      'Certification for safety', 
      'Install outdoor lighting'
    ],
    Plumber: [
      'Fix leaky pipes', 
      'Install a boiler', 
      'Unblock drains', 
      'Install radiators', 
      'Certification for gas safety', 
      'Install bathroom fixtures'
    ],
    Carpenter: [
      'Build custom furniture', 
      'Install kitchen cabinets', 
      'Repair wooden flooring', 
      'Install doors', 
      'Build wooden decking', 
      'Install wooden stairs'
    ],
    Gardener: [
      'Lawn mowing', 
      'Hedge trimming', 
      'Planting flowers', 
      'Garden cleanup', 
      'Landscape design', 
      'Install garden irrigation system'
    ],
    Cleaner: [
      'House cleaning', 
      'Office cleaning', 
      'Deep cleaning', 
      'Window cleaning', 
      'Carpet cleaning', 
      'Post-renovation cleaning'
    ],
    Roofer: [
      'Repair roof leaks', 
      'Install new roofing', 
      'Replace shingles', 
      'Inspect roof for damage', 
      'Install guttering', 
      'Roof insulation'
    ],
    Builder: [
      'Construct walls', 
      'Lay foundations', 
      'Build extensions', 
      'Install windows and doors', 
      'Demolition work', 
      'Construct garages'
    ],
    Plasterer: [
      'Apply plaster to walls', 
      'Repair damaged plaster', 
      'Install plasterboard', 
      'Smooth ceilings', 
      'Decorative plastering', 
      'Plaster insulation walls'
    ],
    Tiler: [
      'Lay floor tiles', 
      'Tile bathroom walls', 
      'Replace cracked tiles', 
      'Install kitchen backsplash', 
      'Grout tiles', 
      'Tile outdoor patios'
    ],
    Handyperson: [
      'Assemble flat-pack furniture', 
      'Hang shelves', 
      'Install curtain rods', 
      'Fix minor plumbing issues', 
      'Basic electrical repairs', 
      'Patch drywall'
    ],
    Painter: [
      'Interior painting',
      'Exterior painting',
      'Paint window frames',
      'Wallpaper removal',
      'Ceiling painting',
      'Touch-up paint jobs'
    ]
  
  
  };
  